// Footer.js
import React from 'react';

const RightPage9 = () => {
  return (
    <footer className="bg-[#f8fcff] text-center py-4 text-sm text-gray-800 border-t">
      <p>
        &copy; Copyright <strong className="font-semibold">iPortfolio</strong> All Rights Reserved
      </p>
      <p className="mt-1">
        Designed by{' '}
        <a
          href="https://bootstrapmade.com"
          className="text-blue-500 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          TailwindMade
        </a>{' '}
        Distributed by{' '}
        <a
          href="https://themewagon.com"
          className="text-blue-500 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          ThemeWagon
        </a>
      </p>
    </footer>
  );
};

export default RightPage9;
